import { ServiceFuture } from '../../../providers/ActivationObjectProvider/types'
import { GenericDropdownItem } from '../../../../types'
import { WizzardStep3Form } from '../types'

export const DefaultValue: WizzardStep3Form = {
    ico: '',
    vat: '',
    emailInvoice: '',
    emailSendingDocumentation: '',
    invoiceAddressName: '',
    invoiceAddressZIP: '',
    invoiceAddressCity: '',
    invoiceAddressGuidanceNumber: '',
    invoiceAddressCodeNumber: '',
    invoiceAddressStreet: '',
}

export const ServiceFutureDesc: Record<ServiceFuture, string | undefined> = {
    Empty: 'Žádná',
    FullProtection: 'Celková ochrana',
    StandardProtection: 'Běžná ochrana',
    BaseProtection: 'Základní ochrana',
    ContactLater: 'Kontaktovat později',
}
export const ServiceFutureDescList: GenericDropdownItem<ServiceFuture>[] =
    Object.keys(ServiceFutureDesc).map((key) => {
        return {
            value: key as ServiceFuture,
            label: (ServiceFutureDesc as any)[key],
        }
    })
